import { render, staticRenderFns } from "./MapaBrasil.vue?vue&type=template&id=85e943c8&scoped=true&"
import script from "./MapaBrasil.vue?vue&type=script&lang=js&"
export * from "./MapaBrasil.vue?vue&type=script&lang=js&"
import style0 from "./MapaBrasil.vue?vue&type=style&index=0&id=85e943c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e943c8",
  null
  
)

export default component.exports